import { promiseConfirm } from '../features/confirm-dialog.js';

export function initializeGlobalClickEvent() {
    document.addEventListener('click', async event => {
        if (event.isSyntheticConfirm) {
            return;
        }

        const target = event.target.closest('button, a');
        if (!target) {
            return;
        }

        if (event.detail > 1) {
            const isActionElement = target.tagName === 'A' || (target.tagName === 'BUTTON' && target.type === 'submit');
            if (isActionElement) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
        }

        const confirmValue = target.dataset.confirm;
        if (!confirmValue || confirmValue === 'false') {
            return;
        }

        const staticValue = target.dataset.confirmStatic;
        const isStatic = ['modal', 'static', 'true'].includes(staticValue);

        const confirmTemplateId = target.dataset.confirmTemplate;

        event.preventDefault();
        event.stopPropagation();

        const confirmMessage = confirmValue === 'true' ? 'Are you sure?' : confirmValue;

        if (await promiseConfirm(confirmMessage, isStatic, confirmTemplateId)) {
            const syntheticEvent = new PointerEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
                detail: 1,
            });
            syntheticEvent.isSyntheticConfirm = true;
            target.dispatchEvent(syntheticEvent);
        }
    }, { capture: true });
}
